import { render, staticRenderFns } from "./Subreddit.vue?vue&type=template&id=ac2a3024&scoped=true&"
import script from "./Subreddit.vue?vue&type=script&lang=js&"
export * from "./Subreddit.vue?vue&type=script&lang=js&"
import style0 from "./Subreddit.vue?vue&type=style&index=0&id=ac2a3024&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac2a3024",
  null
  
)

export default component.exports